<template>
  <div></div>
</template>
<script>
export default {
  data() {
    return {
      basic_url: Config.dev_url,
    }
  },
  methods: {
    classifyChange(item, selData) {
      console.log(item, selData)
      var url = this.basic_url + "/api-apps/customization/findTechnicalByEquipment/" + selData.equipmentclassify;
      this.$axios.get(url, {}).then((res) => {
        var technicalList = [];
        for (var i = 0; i < res.data.length; i++) {
          var obj = {};
          obj.parametername = res.data[i].assetattr;
          obj.unitofmeasurement = res.data[i].unit;
          technicalList.push(obj)
        }
        if (!!this.$store.state.detailInfo.id) {
          this.$store.state.detailInfo.technicalList = technicalList;
          this.saveData();
        } else {
          this.$store.state.childrensInfo.technicalList = [];
          this.$store.state.childrensInfo.technicalList = technicalList;
          this.$store.dispatch("setisUsefalsepageAct", true)
          this.$store.commit('setDataChangeStatus', 1)
        }
      }).catch((wrong) => {
      })
    },
    saveData() {
      var url = this.basic_url + "/api-apps/app/assetApp/addOrEdit";
      var data = this.$store.state.detailInfo
      this.$axios.post(url, data).then((res) => {
      }).catch((wrong) => {
      })
    },
    // 清空设备分类
    clearClassify(item, data) {
      this.$confirm("是否清除记录？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(({ value }) => {
          this.clearInputBtnData(item, data);//确定删除
        })
        .catch(() => {
        });
    },
    //弹出框确定按钮
    clearInputBtnData(item, data) {
      if (!!this.$store.state.detailInfo.id) {
        var url = this.basic_url + "/api-apps/customization/deleteTechnicalspecificationByAssetnum/" + this.$store.state.detailInfo.assetnum;
        this.$axios.delete(url).then((res) => {
          if (res.data.code == 0) {
            this.$store.state.detailInfo[item.model] = '';
            this.$store.state.detailInfo.classifyEnity_classifydescribe = '';
            this.$store.state.childrensInfo.technicalList = [];
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning"
            });
          }
        }).catch((err) => {
        });
      } else {
        this.$store.state.detailInfo[item.model] = '';
        this.$store.state.detailInfo.classifyEnity_classifydescribe = '';
        this.$store.state.childrensInfo.technicalList = [];
      }
    },
  }
}
</script>